
<div class="sus-people mb-footer">
    <!-- section 1 contents -->
    <div class="sec-1">
        <div class="container">
            <div class="row">
                <!-- title -->
                <div class="col-md-12 my-md-5 mb-5 sec-title">
                    <app-title-page [dataTitle]="dataTitle" [link]="'#people-able'"></app-title-page>
                </div>
                <!-- detail -->
                <div class="col-md-12" id="people-able">
                    <div class="lane-top pt-5">
                        <div class="row">
                            <div class="col-xl-5 col-lg-6 col-md-8">
                                <h6 class="mini-tit">{{ dataSection[0]?.title }}</h6>
                            </div>
                            <div class="col-md-12">
                                <div class="desc text-justify" [innerHTML]="dataSection[0]?.content"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> 
    <!-- section 2 contents -->
    <div class="sec-2 mt-5 bg-headline d-flex align-items-center"
        [ngStyle]="{'background-image' : 'url('+ apiAsset + dataSection[1]?.picture +')'}">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-md-7">
                    <h3>{{ dataSection[1]?.title }}</h3>
                </div>
            </div>
        </div>
    </div>
    <!-- section 3 contents  -->
    <div class="sec-3">
        <div class="container-fluid bg-absolute">
            <div class="row h-100">
                <div class="col-md-5 bg-gray">
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <app-vision-mision [borderTop]="false" 
                                       [dataVisi]="dataSection[2]"
                                       [dataMisi]="dataSection[3]">
                    </app-vision-mision>
                </div>
            </div>
        </div>
    </div>
    <div class="sec-4 mt-5">
        <div class="container">
            <div class="row">
                <!-- social investment detail -->
                <div class="col-md-12">
                    <div class="row list-circle padlist no-list circle-blue">
                        <div class="col-md-5">
                            <h6 class="mini-tit">{{ dataSection[4]?.title }}</h6>
                        </div>
                        <div class="col-md-12">
                            <div class="text-justify desc" [innerHTML]="dataSection[4]?.content"></div>
                        </div>
                    </div>
                </div>
                 <!-- social investment pillars -->
                 <div class="col-md-12 mt-5">
                    <div class="social-pillars lane-top">
                        <h3 class="title f-subtit text-center mt-5">{{ dataSection[5]?.title }}</h3>
                        <div class="row justify-content-center">
                            <div class="col-lg-4 col-md-6 py-3" *ngFor="let pillar of dataSection[5]?.card">
                                <div class="border-type-1 pillar no-list p-3">
                                    <div class="picture" [ngStyle]="{'background-image' : 'url('+ apiAsset + pillar.picture +')'}"></div>
                                    <div class="position-relative">
                                        <h6 class="mini-tit mb-5">{{ pillar.title }}</h6>
                                        <div class="detail" [innerHTML]="pillar.description"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                 </div>
            </div>
        </div>
    </div>
</div>
